import React from 'react';
import { useCurrentUser } from '../contexts/CurrentUserContext';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';
import { clearExternalAccess } from '../utils/externalAccess';

// Holds the app back until /me has answered, so no page renders menus or forms for a role it cannot use.
export default function AccessGate({ children }) {
  const { status, retry } = useCurrentUser();
  const { language } = useLanguage();
  const t = translations[language];

  if (status === 'ready') return children;

  if (status === 'loading') {
    return <main className="splash" aria-live="polite">Validating access…</main>;
  }

  const signOut = () => {
    clearExternalAccess();
    window.location.assign('/login');
  };

  if (status === 'forbidden') {
    return <main className="auth">
      <div className="card auth__card stack" role="alert">
        <h1>{t.noAccessTitle}</h1>
        <p>{t.noAccessBody}</p>
        <div className="btn-row"><button className="btn btn--primary" type="button" onClick={signOut}>{t.logout}</button></div>
      </div>
    </main>;
  }

  return <main className="auth">
    <div className="card auth__card stack" role="alert">
      <p>{t.accessCheckFailed}</p>
      <div className="btn-row"><button className="btn btn--primary" type="button" onClick={retry}>{t.tryAgain}</button></div>
    </div>
  </main>;
}
